import Vue from "vue";
let currentRequest = 0;

const CustomerTypeService = {
  async fetchAll(searchFilterPagination) {
    try {
      const request = ++currentRequest;
      console.log(`[${request}] START CUSTOMER_TYPE `, searchFilterPagination.search);
      const res = await Vue.$jsonApi.findAll(
        "customer_types",
        searchFilterPagination
      );
      if (request !== currentRequest) {
        console.log(`[${request}] CUSTOMER_TYPE DISCARDED`);
        return null;
      }
      console.log(`[${request}] END CUSTOMER_TYPE `, searchFilterPagination.search);
      return res;
    } catch (error) {
      console.log("fetchAll error: ", error);
      return { error: error };
    }
  }
};

export { CustomerTypeService };
